import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type OpenIssuesPanelEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const openIssuesPanelEntryPoint: EntryPoint<OpenIssuesPanelEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<OpenIssuesPanelEntryPointComponent>(
			/* webpackChunkName: "async-servicedesk-proactive-support-open-issues-panel" */ './OpenIssuesPanel.tsx',
		),
		getPreloadProps: () => ({}),
	});
